import { render, staticRenderFns } from "./codeManagement.vue?vue&type=template&id=35a36ed2&scoped=true"
import script from "./codeManagement.vue?vue&type=script&lang=js"
export * from "./codeManagement.vue?vue&type=script&lang=js"
import style0 from "./codeManagement.vue?vue&type=style&index=0&id=35a36ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a36ed2",
  null
  
)

export default component.exports